import { Dispatch } from 'react';
import { Approval } from '../approval';
import {
  ITeamRequestState,
  TeamRequestAction,
  TeamRequestContainer,
} from '../team-request';
import { RequestStatusTeam } from '../request-status-team';
import { Request as HelpDeskRequest } from '../help-desk';
import { IUser } from '../common';

export const panels = ({
  teamRequestState,
  dispatchTeamRequest,
}: {
  teamRequestState: ITeamRequestState;
  dispatchTeamRequest: Dispatch<TeamRequestAction>;
}) => [
  {
    value: 0,
    panel: () => <Approval title="Team Approvals" />,
  },
  {
    value: 1,
    panel: () => (
      <TeamRequestContainer
        teamRequestState={teamRequestState}
        dispatchTeamRequest={dispatchTeamRequest}
      />
    ),
  },
  {
    value: 2,
    panel: () => <RequestStatusTeam />,
  },
  {
    value: 3,
    panel: () => (
      <HelpDeskRequest
        key="Search Users"
        searchUsers
        forRegistrantsNCoordinators
      />
    ),
  },
];
